"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const HtmlHelper_1 = require("./services/HtmlHelper");
const useSetPaymentModal_1 = require("./hooks/useSetPaymentModal");
const system_1 = require("@mui/system");
const TextHelper_1 = require("./services/TextHelper");
const InfoPopup_1 = require("./components/parts/InfoPopup");
const useConfig_1 = require("./hooks/useConfig");
const useSetInfoCloseFnRef_1 = require("./hooks/useSetInfoCloseFnRef");
const useBreakdownData_1 = require("./hooks/useBreakdownData");
const useCalcResponse_1 = require("./hooks/useCalcResponse");
const useActions = () => {
    const setPaymentModal = (0, useSetPaymentModal_1.useSetPaymentModal)();
    return {
        openPaymentOptions: () => setPaymentModal(true),
        instalmentOptions: () => null,
        anotherAction: () => console.log('Another action!'),
    };
};
const StyledInstalmentOptions = (0, system_1.styled)(material_1.Box)(({ theme }) => ({
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.custom.surfaceMedium,
    '& .additionalItemsHeader': {
        display: 'flex',
        color: theme.palette.custom.textMedium,
        marginBottom: theme.spacing(1),
    },
    '& .refs': {
        fontSize: '0.8em',
        paddingLeft: '5px',
        marginTop: '-10px',
    },
}));
const StyledBreakdownItem = (0, system_1.styled)(material_1.Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 0,
    color: theme.palette.custom.textMedium,
    '& .breakdown-item-title': {
        color: theme.palette.custom.textLight,
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        minHeight: '28px',
    },
    '& .breakdownItemValue': {
        color: theme.palette.custom.textMedium,
        fontSize: '13px',
    },
}));
const StyledBoxContainer = (0, system_1.styled)(material_1.Box)(() => ({
    display: 'flex',
    alignItems: 'center',
}));
function getActionComponent(actionName, displayText) {
    const actions = useActions();
    const config = (0, useConfig_1.useConfig)();
    const breakdownData = (0, useBreakdownData_1.useBreakdownData)();
    let yearData = null;
    if (breakdownData.years.length > 0) {
        yearData = breakdownData.years[0];
    }
    const setInfoCloseFnRef = (0, useSetInfoCloseFnRef_1.useSetInfoCloseFnRef)();
    const actionComponents = {
        openPaymentOptions: ({ displayText, onClick }) => ((0, jsx_runtime_1.jsx)(material_1.Link, { sx: { cursor: 'pointer' }, color: 'inherit', onClick: onClick, children: displayText })),
        instalmentOptions: ({ displayText }) => {
            var _a;
            if (!((_a = yearData === null || yearData === void 0 ? void 0 : yearData.instalmentOptions) === null || _a === void 0 ? void 0 : _a.length))
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            return ((0, jsx_runtime_1.jsxs)(StyledInstalmentOptions, { children: [(0, jsx_runtime_1.jsx)("div", { className: "additionalItemsHeader", children: (0, jsx_runtime_1.jsx)("div", { className: "col-left", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: (0, jsx_runtime_1.jsx)("strong", { children: displayText
                                        ? displayText
                                        : `Instalment Options for ${yearData.year}` }) }) }) }), yearData.instalmentOptions.map((item, index) => {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                        return ((0, jsx_runtime_1.jsxs)(StyledBreakdownItem, { children: [(0, jsx_runtime_1.jsxs)(StyledBoxContainer, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", className: "breakdown-item-title", children: item.label }), item.info && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { zIndex: 9999 }, children: (0, jsx_runtime_1.jsx)(InfoPopup_1.InfoPopup, { popId: item.key, infos: [item.info], getCloseInfoRef: (cb) => setInfoCloseFnRef(cb) }) }))] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", className: "breakdown-item-value", children: (0, TextHelper_1.formatNumberCurrency)((0, TextHelper_1.roundNumber)(item.amount, (_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.fees) === null || _a === void 0 ? void 0 : _a.instalmentOptions) === null || _b === void 0 ? void 0 : _b.rounding) === null || _c === void 0 ? void 0 : _c.type, (_f = (_e = (_d = config === null || config === void 0 ? void 0 : config.fees) === null || _d === void 0 ? void 0 : _d.instalmentOptions) === null || _e === void 0 ? void 0 : _e.rounding) === null || _f === void 0 ? void 0 : _f.precision), (_j = (_h = (_g = config === null || config === void 0 ? void 0 : config.fees) === null || _g === void 0 ? void 0 : _g.instalmentOptions) === null || _h === void 0 ? void 0 : _h.rounding) === null || _j === void 0 ? void 0 : _j.displayDecimals, config === null || config === void 0 ? void 0 : config.terms) })] }, index));
                    })] }));
        },
        anotherAction: ({ displayText, onClick }) => ((0, jsx_runtime_1.jsx)("button", { onClick: onClick, children: displayText })),
    };
    if (actionName in actions) {
        const ActionComponent = actionComponents[actionName];
        const onClick = actions[actionName];
        return ActionComponent ? ((0, jsx_runtime_1.jsx)(ActionComponent, { displayText: displayText, onClick: onClick })) : ((0, jsx_runtime_1.jsxs)("span", { style: { color: 'red' }, children: ["Action ", actionName, " not defined."] }));
    }
    return null;
}
function parseAndRenderContent(text, index) {
    var _a, _b, _c, _d;
    const config = (0, useConfig_1.useConfig)();
    const calcResponse = (0, useCalcResponse_1.useCalcResponse)();
    const macroRegex = /<macro action=([\w]+)>(.*?)<\/macro>|<macro action=([\w]+)><\/macro>/g;
    const optionalFeeRegex = /<macroOptionalFees\s+(?:id=([\w-]+)|type=([\w]+)|field=([\w]+))\s*(?:id=([\w-]+)|type=([\w]+)|field=([\w]+))?\s*(?:id=([\w-]+)|type=([\w]+)|field=([\w]+))?\s*>/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    while ((match = macroRegex.exec(text)) !== null) {
        const [fullMatch, actionNameWithContent, displayTextWithContent, actionNameWithoutContent,] = match;
        const macroStart = match.index;
        if (macroStart > lastIndex) {
            const rawHtml = text.slice(lastIndex, macroStart);
            parts.push((0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: (0, HtmlHelper_1.sanitizeHtmlString)(rawHtml) } }, `html-${lastIndex}`));
        }
        const actionName = actionNameWithContent || actionNameWithoutContent;
        const displayText = displayTextWithContent || '';
        const actionComponent = getActionComponent(actionName, displayText);
        if (actionComponent) {
            parts.push(actionComponent);
        }
        else {
            parts.push((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: fullMatch }, `macro-${macroStart}`));
        }
        lastIndex = macroRegex.lastIndex;
    }
    const remainingText = text.slice(lastIndex);
    lastIndex = 0;
    while ((match = optionalFeeRegex.exec(remainingText)) !== null) {
        const [, id1, type1, field1, id2, type2, field2, id3, type3, field3] = match;
        const macroStart = match.index;
        if (macroStart > lastIndex) {
            const rawHtml = text.slice(lastIndex, macroStart);
            parts.push((0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: (0, HtmlHelper_1.sanitizeHtmlString)(rawHtml) } }, `html-${lastIndex}`));
        }
        const id = id1 || id2 || id3;
        const type = type1 || type2 || type3;
        const field = field1 || field2 || field3 || '';
        if (id) {
            const fee = (_d = (_c = (_b = (_a = calcResponse.data.years[index || 0]) === null || _a === void 0 ? void 0 : _a.family) === null || _b === void 0 ? void 0 : _b.fees) === null || _c === void 0 ? void 0 : _c.optionalFees) === null || _d === void 0 ? void 0 : _d.find((fee) => fee.id === id && (!type || fee.type === type));
            if (fee) {
                const fieldKey = field;
                const fieldValue = fee[fieldKey];
                let formattedValue;
                if (typeof fieldValue === 'number') {
                    formattedValue = `<strong>${(0, TextHelper_1.formatNumberCurrency)(Math.abs(fieldValue), 'ifPresent', config === null || config === void 0 ? void 0 : config.terms)}</strong>`;
                }
                else if (typeof fieldValue === 'string' &&
                    /^\d{4}-\d{2}-\d{2}$/.test(fieldValue)) {
                    const [year, month, day] = fieldValue.split('-');
                    formattedValue = `<strong>${day}/${month}/${year}</strong>`;
                }
                else if (typeof fieldValue === 'string') {
                    formattedValue = `<strong>${fieldValue}</strong>`;
                }
                else {
                    formattedValue = '';
                }
                parts.push((0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: formattedValue } }, `optional-fee-${id}-${type}-${field}`));
            }
        }
        lastIndex = optionalFeeRegex.lastIndex;
    }
    if (lastIndex < remainingText.length) {
        const remainingHtml = remainingText.slice(lastIndex);
        parts.push((0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: (0, HtmlHelper_1.sanitizeHtmlString)(remainingHtml) } }, `html-${lastIndex}`));
    }
    return parts;
}
const MacroRenderer = ({ text, index }) => {
    const renderedContent = parseAndRenderContent(text, index);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: renderedContent.map((item, i) => ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: item }, i))) }));
};
exports.default = MacroRenderer;
